<template>
  <div class="item">
    <div class="plot-item-content">
      <template v-if="!isInitial">
        <div class="item-handle handle-disp" />
        <div class="delete-button handle-disp" @click="deleteItem">×</div>
      </template>
      <textarea class="plot-card" v-model="inputValue" :placeholder="$t('plotEditPage.plotItemDetail.placeholder')" maxlength="2500" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

interface Props {
  value: string;
  isInitial: boolean;
}

interface Data {}

interface Computed {
  inputValue: string;
}

interface Methods {
  deleteItem(e: MouseEvent): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    value: String,
    isInitial: Boolean,
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    deleteItem(e) {
      this.$emit("deleteItem", e);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.item {
  width: 200px;
  height: 200px;
  border-radius: var(--radius-xs);
  text-decoration: none;

  .plot-item-content {
    position: relative;
    box-sizing: border-box;
    vertical-align: middle;
    width: 100%;
    height: 100%;
    background: var(--color-background-normal);
    color: var(--color-text-normal);
    border-radius: var(--radius-xs);
    border: solid 1px var(--color-border);
    box-shadow: var(--shadow-sm);
    cursor: pointer;

    .item-handle {
      width: 100%;
      height: 19px;
    }

    /* 掴んで移動可能な領域 */
    .handle-disp {
      display: none;
      position: absolute;

      background-color: transparent;
      transition: background-color 0.8s ease-in-out;
    }

    &:hover {
      .handle-disp {
        display: block;
        background-color: var(--color-surface-hover);

        animation-name: plot-item-fadeIn;
        animation-duration: 0.5s;
      }
    }
  }

  .delete-button {
    position: absolute;
    width: 19px;
    height: 19px;
    padding: 0;
    font-size: var(--font-size-sm);
    text-align: center;
    vertical-align: middle;
    border: none;
    background-color: var(--color-surface-subtle);
    color: var(--color-text-normal);
    right: 0;
    top: 0;
  }

  .plot-card {
    font-size: 16.1px;
    width: calc(100% - 20px);
    height: calc(100% - 35px);
    resize: none;
    margin: 10px;
    margin-top: 25px;
    padding: 0;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: var(--color-background-normal);
    color: var(--color-text-normal);
  }

  &:last-child {
    .plot-item-content {
      cursor: default;
    }
  }
}

@keyframes plot-item-fadeIn {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
